import { Box } from '@apia/theme';
import { TTreeLabelRenderer } from '../types';

const DefaultLabelRenderer: TTreeLabelRenderer = (props) => {
  return <Box as="span">{props.label}</Box>;
};

export default DefaultLabelRenderer;
